export default "__VITE_ASSET__EUsdO1oR__"